"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var CatMarken32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M21.655 8.246c-1.157 0-2.099.941-2.099 2.098a2.1 2.1 0 004.109.606 8.079 8.079 0 001.943-.388v6.093c0 .304-.118.587-.333.798l-10.36 10.36a.726.726 0 01-1.026 0l-9.705-9.705a.72.72 0 010-1.026l10.36-10.359c.219-.215.503-.333.799-.333h9.538a.73.73 0 01.728.728V9.53a6.984 6.984 0 01-1.888.441 2.106 2.106 0 00-2.065-1.726zm-.262 1.689a.49.49 0 00.148.887c.308.072.662.121 1.055.144a1.133 1.133 0 01-.945.514 1.132 1.132 0 111.074-1.483 5.378 5.378 0 01-.964-.126.481.481 0 00-.368.063zm3.487-4.511h-1.358a2.339 2.339 0 014.501.887c.004 1.043-.406 1.898-1.218 2.541a3.753 3.753 0 01-.229.17V7.12c0-.935-.761-1.696-1.696-1.696zM25.689 3a3.32 3.32 0 00-2.04.708 3.341 3.341 0 00-1.152 1.712h-7.156c-.562 0-1.089.218-1.485.614L3.496 16.398c-.321.32-.497.747-.497 1.2s.177.879.497 1.2l9.705 9.705c.321.321.748.498 1.202.498s.881-.177 1.202-.498l10.36-10.36c.396-.396.614-.923.614-1.485v-6.504c.292-.153.572-.335.834-.543 1.038-.831 1.586-1.974 1.586-3.304a3.312 3.312 0 00-3.311-3.306z" }))); };
var StyledCatMarken32 = styled_components_1.default(CatMarken32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatMarken32;
var templateObject_1;
//# sourceMappingURL=CatMarken32.js.map